import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Users, Sparkles, GraduationCap } from 'lucide-react';
import { useHomepageConfig } from '@/hooks/useHomepageConfig';
import { Editable } from '@/components/edit/Editable';

const DEFAULT_ICONS = [Users, Sparkles, GraduationCap];

const COLUMNS = [
  {
    Icon: Users,
    title: 'About Our Staff',
    body: 'Our combined staff has either lived or studied in Brasil over the years. We have some of the top experienced professionals in the country with many years of experience about the Carnaval in Brasil and Afro-Brasilian cultural traditions.',
    linkLabel: 'Staff',
    to: '/about#members',
  },
  {
    Icon: Sparkles,
    title: 'About What We Do',
    body: 'Escola de Samba Casa Samba has many service options. Please take a look at the Performances, programs and services that we offer. All programs are completely customizable. Serving with excellence and professionalism since 1987.',
    linkLabel: 'View Services',
    to: '/performances',
  },
  {
    Icon: GraduationCap,
    title: 'Special Classes',
    body: "Learn traditional dances & drum rhythms of Brasil. Dance classes with live musicians playing traditional Brasilian rhythms, children's classes, samba percussion and Capoeira Angola.",
    linkLabel: 'View Classes',
    to: '/classes',
  },
];

export const HomeThreeColumnServices = () => {
  const cfg = useHomepageConfig();
  const columns = (cfg?.threeColumns && cfg.threeColumns.length === 3) ? cfg.threeColumns : COLUMNS;

  return (
    <section
      className="py-16 md:py-20 px-6 relative bg-black/30 backdrop-blur-md border-y border-white/10"
      data-testid="home-three-col-services"
    >
      <div className="max-w-6xl mx-auto">
        {/* Three columns */}
        <div className="grid md:grid-cols-3 gap-10 md:gap-12">
          {columns.map((col, idx) => {
            const Icon = DEFAULT_ICONS[idx] || Sparkles;
            return (
              <motion.div
                key={col.title + idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.08 }}
                className="text-center"
              >
                <div className="flex justify-center mb-4">
                  <Icon className="w-8 h-8 text-white" strokeWidth={1.5} />
                </div>
                <Editable
                  as="h3"
                  path={`threeColumns.${idx}.title`}
                  fallback={col.title}
                  className="text-white font-black uppercase tracking-widest text-sm md:text-base mb-4"
                />
                <Editable
                  as="p"
                  path={`threeColumns.${idx}.body`}
                  fallback={col.body}
                  className="text-white/90 text-sm leading-relaxed max-w-xs mx-auto"
                  multiline
                />
                <Link
                  to={col.to || '#'}
                  className="mt-6 inline-block text-white/95 hover:text-yellow-300 font-semibold text-sm tracking-widest uppercase transition-colors"
                  data-testid={`svc-link-${(col.linkLabel || '').toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <Editable path={`threeColumns.${idx}.linkLabel`} fallback={col.linkLabel} />
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeThreeColumnServices;
